<template>
    <div>
        <div class="content-header">
            <div class="content-header-left mb-2">
                <div class="breadcrumbs-top">
                    <h2 class="content-header-title mb-0">{{ title }}</h2>
                    <div class="breadcrumb-wrapper">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="role_id == 2 ? '/' : '/kontrak'">
                                    <i class="feather icon-home"></i>
                                </router-link>
                            </li>

                            <li class="breadcrumb-item" :class="data.active == true ? 'active' : ''"
                                style="text-transform: capitalize" v-for="(data, index) in breadcumb" :key="index">
                                <router-link :to="data.link">{{ data.name }}</router-link>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section>
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <h3 class="font-bold text-primary mb-2 d-flex justify-content-between">
                                <span>Informasi Material </span>
                                <router-link to="/smartlog" class="btn btn-primary">Kembali</router-link>
                            </h3>
                            <hr>
                            <div class="row">
                                <!-- Gallery Mobile View -->
                                <div class="col-12 d-md-none mb-2 border rounded py-2">
                                    <div v-if="model.galleries?.length > 1" id="carouselMobile" class="carousel slide"
                                        data-ride="carousel">
                                        <ol class="carousel-indicators">
                                            <li data-target="#carouselMobile" :data-slide-to="index"
                                                v-for="(data, index) in model.galleries" :key="index"
                                                :class="showImage == index ? 'active' : ''">
                                            </li>
                                        </ol>
                                        <div class="carousel-inner" style="border-radius: 5%;">
                                            <div class="carousel-item" style="cursor: pointer;"
                                                :class="showImage == index ? 'active' : ''"
                                                v-for="(data, index) in model.galleries" :key="index">
                                                <img class="d-block img-carousel" :src="data.image"
                                                    @click="viewImage(data.image)">
                                            </div>
                                        </div>
                                        <a class="carousel-control-prev" href="#carouselMobile" role="button"
                                            data-slide="prev">
                                            <div class="btn btn-primary btn-sm">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="sr-only">Previous</span>
                                            </div>
                                        </a>
                                        <a class="carousel-control-next" href="#carouselMobile" role="button"
                                            data-slide="next">
                                            <div class="btn btn-primary btn-sm">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="sr-only">Next</span>
                                            </div>
                                        </a>
                                    </div>
                                    <div v-else-if="model.galleries?.length == 1" class="d-flex justify-content-center"
                                        style="cursor: pointer;">
                                        <img :src="model.galleries[0]['image']" class="img-carousel"
                                            @click="viewImage(model.galleries[0]['image'])">
                                    </div>
                                    <img v-else src="/assets/img/empty.png" class="img-carousel" alt="Empty Image"
                                        @click="viewImage('/assets/img/empty.png')" style="cursor: pointer;">
                                </div>
                                <!-- Gallery Mobile View -->

                                <!-- Detail Material -->
                                <div class="col-md-7">
                                    <div class="row">
                                        <TextGroup label="Nama Material" :value="model.name" />
                                        <TextGroup label="ID Material" :value="model.code" />
                                        <TextGroup label="Kategori" :value="model.category?.name" />
                                        <TextGroup label="Sub Kategori" :value="model.sub_category?.name" />
                                        <TextGroup label="Kategori Material" :value="model.material_category" />
                                        <TextGroup label="Kondisi Material">
                                            <span style="background-color: #c2eeff; padding: 0.4rem; color:#165a75"
                                                class="rounded-sm">{{ model.type }}</span>
                                        </TextGroup>
                                        <TextGroup label="Keadaan Material">
                                            <span v-for="(item, i) in model.conditions" :key="i"
                                                style="background-color: #c2eeff; padding: 0.4rem; color:#165a75"
                                                class="rounded-sm">{{ item.name }}</span>
                                        </TextGroup>
                                        <TextGroup label="Spesifikasi" :value="model.specification" />
                                    </div>

                                    <hr style="border-top: 2px dashed #c1c7c9;">

                                    <div class="row">
                                        <TextGroup label="Kontrak Asal" :value="model.contract?.contract_title" />
                                        <TextGroup label="Nomor Kontrak" :value="model.contract?.contract_number" />

                                        <div class="col-md-12">
                                            <label for="">Attachment</label>
                                        </div>
                                        <div class="col-md-12">
                                            <ul class="list-unstyled">
                                                <li class="mb-1"
                                                    v-for="(attachment, key) in model?.contract?.attachments"
                                                    :key="key">
                                                    <a @click.prevent="viewAttachment(attachment)"
                                                        :href="attachment?.url" target="_blank" class="btn"
                                                        style="background-color: #c2eeff; padding: 1rem; color:#165a75">
                                                        <i class="fa fa-file fa-lg text-blue" aria-hidden="true"></i> {{
                                                        attachment?.name }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>

                                        <TextGroup label="Merek" :value="model.manufacturer?.brand?.name" />
                                        <TextGroup label="Pabrik" :value="model.manufacturer?.factory?.name" />
                                        <TextGroup label="Tahun Pembuatan" :value="model.manufacturer?.year" />
                                        <TextGroup label="Negara Produksi" :value="model.manufacturer?.country?.name" />
                                    </div>

                                    <hr style="border-top: 2px dashed #c1c7c9;">

                                    <div class="row">
                                        <TextGroup label="Lokasi" :value="model.storage?.unit?.name" />
                                        <TextGroup label="Gudang" :value="model.storage?.warehouse?.name" />
                                        <TextGroup label="Stock">
                                            {{ model.storage?.stock }} {{ model.storage?.material_unit?.name }}
                                        </TextGroup>
                                        <TextGroup label="Kontak Person">
                                            {{ model.storage?.contact_person?.name }} - {{ model.storage?.contact_person?.phone_number }}
                                        </TextGroup>
                                        <TextGroup label="Status" :value="model.code">
                                            <span class="badge badge-success" v-if="model.storage?.stock > 0">
                                                {{ model.status }}
                                            </span>
                                            <span class="badge badge-danger" v-else>
                                                Tidak Tersedia
                                            </span>
                                        </TextGroup>
                                    </div>
                                </div>
                                <!-- Detail Material -->

                                <!-- Gallery On Dekstop View -->
                                <div class="col-md-5 d-none d-md-block">
                                    <div v-if="model.galleries?.length > 1" id="carouselDekstop" class="carousel slide"
                                        data-ride="carousel">
                                        <ol class="carousel-indicators">
                                            <li data-target="#carouselDekstop" :data-slide-to="index"
                                                v-for="(data, index) in model.galleries" :key="index"
                                                :class="showImage == index ? 'active' : ''">
                                            </li>
                                        </ol>
                                        <div class="carousel-inner" style="border-radius: 5%;">
                                            <div class="carousel-item" style="cursor: pointer;"
                                                :class="showImage == index ? 'active' : ''"
                                                v-for="(data, index) in model.galleries" :key="index">
                                                <img class="d-block img-carousel" :src="data.image"
                                                    @click="viewImage(data.image)">
                                            </div>
                                        </div>
                                        <a class="carousel-control-prev" href="#carouselDekstop" role="button"
                                            data-slide="prev">
                                            <div class="btn btn-primary btn-sm">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="sr-only">Previous</span>
                                            </div>
                                        </a>
                                        <a class="carousel-control-next" href="#carouselDekstop" role="button"
                                            data-slide="next">
                                            <div class="btn btn-primary btn-sm">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="sr-only">Next</span>
                                            </div>
                                        </a>
                                    </div>
                                    <div v-else-if="model.galleries?.length == 1" class="d-flex justify-content-center"
                                        style="cursor: pointer;">
                                        <img :src="model.galleries[0]['image']" class="img-carousel"
                                            @click="viewImage(model.galleries[0]['image'])">
                                    </div>
                                    <img v-else src="/assets/img/empty.png" class="img-carousel"
                                        style="cursor: pointer;" alt="Empty Image"
                                        @click="viewImage('/assets/img/empty.png')">
                                </div>
                                <!-- Gallery On Dekstop View -->
                            </div>
                            <hr style="border-top: 2px dashed #c1c7c9;">

                            <!-- List Riwayat keluar masuk -->
                            <div class="row mt-2">
                                <div class="col-12">
                                    <Datatable :dataTable="dataTable" :noAction="true">
                                        <template v-slot:title>
                                            <h3 class="font-bold text-primary">
                                                <span>Riwayat Keluar/Masuk </span>
                                            </h3>
                                        </template>

                                        <template v-slot:button>
                                            <button v-can="'material/stock_movement/create'" type="button"
                                                class="btn btn-primary" data-toggle="modal"
                                                data-target="#modal-form-riwayat" @click="resetModel">Tambah
                                                Keluar/Masuk
                                            </button>
                                        </template>

                                        <template v-slot:search>
                                            <div class="input-group form-search-rounded w-100">
                                                <input class="form-control py-2 border-right-0 border" v-model="search"
                                                    type="search" id="example-search-input" placeholder="Cari">
                                                <span class="input-group-append">
                                                    <div class="input-group-text bg-transparent">
                                                        <span class="text-blue">
                                                            <i class="fa fa-search"></i>
                                                        </span>
                                                    </div>
                                                </span>
                                            </div>
                                        </template>

                                        <template v-slot:columnHeader>
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th @click="sortBy('date')">
                                                        Tanggal
                                                        <i class="fa sort"
                                                            :class="currentSort == 'date' ? currentSortDir == 'asc' ? 'fa-sort-down' : currentSortDir == 'desc' ? 'fa-sort-up' : 'fa-sort' : 'fa-sort'"></i>
                                                    </th>
                                                    <th>Type</th>
                                                    <th>Jumlah</th>
                                                    <th>Link Bukti</th>
                                                    <th>Sisa Stok</th>
                                                </tr>
                                            </thead>
                                        </template>
                                    </Datatable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <!-- pop up preview image -->
        <ModalB4 title="Preview Gambar" id="previewImage">
            <img :src="preview_image" alt="" class="h-100 w-100" v-if="preview_image">
            <img v-else src="/assets/img/empty.png" class="img-carousel" alt="Empty Image">
            <template #footer>
                <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Tutup</button>
            </template>

        </ModalB4>
        <!-- pop up preview image end -->

        <!-- form tambah riwayat keluar masuk -->
        <ModalB4 title="Tambah Masuk/Keluar" id="modal-form-riwayat">
            <FormRiwayat ref="formStock" :material_id="$route.params.material_id" @deleted="reloadPage"
                @saved="reloadPage" />
        </ModalB4>
        <!-- form tambah riwayat keluar masuk end -->

        <!-- Pop Up View Attachment -->
        <ModalB4 title="View File" id="modal-view-attachment" size="xl">
            <div v-if="attachmentPdf" style="height: 80vh">
                <!-- Untuk PDF -->
                <iframe v-if="isPdf" :key="attachmentPdf" :src="attachmentPdf" style="width:100%; height:100%;"
                    frameborder="1"></iframe>

                <!-- Untuk Gambar -->
                <div v-else class="d-flex justify-content-center align-items-center" style="height: 100%;">
                    <img :src="attachmentPdf" alt="Image preview" style="max-width: 100%; max-height: 100%;" />
                </div>
            </div>
            <template #footer>
                <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Tutup</button>
            </template>
        </ModalB4>
        <!-- Pop Up View Attachment End -->
    </div>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
import ModalB4 from '@/components/ModalB4.vue'
import FormRiwayat from '../riwayat/Form.vue'
import TextGroup from '@/components/TextGroup.vue'
export default {
    components: {
        Datatable, ModalB4, FormRiwayat, TextGroup
    },
    data() {
        return {
            title: "Detail Material",
            breadcumb: [
                {
                    name: 'SmartLog',
                    link: '/smartlog',
                    active: false
                },
                {
                    name: 'Detail Material',
                    link: '',
                    active: true
                }
            ],
            model: [],
            role_id: localStorage.getItem('role_id'),
            showImage: 0,
            dataTable: {
                lists: [],
                columns: ['date', 'type_text', 'qty', 'attachments', 'remaining_stock']
            },
            attachmentPdf: null,
            isPdf: false,
            search: null,
            currentSort: 'id',
            currentSortDir: 'desc',
            preview_image: null,
        }
    },
    methods: {
        get() {
            let _ = this
            const id = _.$route.params.material_id
            _.axios.get(`/materials/${id}`)
                .then(resp => {
                    _.model = resp.data.data
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        getStockMovement(page) {
            let _ = this
            _.axios.get('/material-stock-movements', {
                params: {
                    search: _.search,
                    page: page,
                    sort: _.currentSortDir,
                    orderby: _.currentSort,
                    material_id: _.$route.params.material_id
                }
            })
                .then(resp => {
                    _.dataTable.lists = resp.data.data
                })
                .catch(err => {
                    console.log(err.response);
                })
        },
        reloadPage() {
            this.get()
            this.getStockMovement()
        },
        resetModel() {
            this.$refs.formStock.resetModel()
        },
        viewAttachment(attachment) {
            const url = attachment.url;
            const extension = url.split('.').pop().toLowerCase();

            const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
            const pdfExtensions = ['pdf'];

            if (pdfExtensions.includes(extension)) {
                this.isPdf = true;
                this.attachmentPdf = url;
                window.$('#modal-view-attachment').modal('show');
            } else if (imageExtensions.includes(extension)) {
                this.isPdf = false;
                this.attachmentPdf = url;
                window.$('#modal-view-attachment').modal('show');
            } else {
                // File tidak didukung
                this.$swal.fire({
                    text: "File ini tidak bisa ditampilkan. Unduh file?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#44A8BD',
                    cancelButtonColor: '#D95E6A',
                    confirmButtonText: 'Ya',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        window.open(url);
                    }
                });
            }
        },
        viewImage(src) {
            this.preview_image = src
            window.$('#previewImage').modal('show')
        },
        sortBy(x) {
            if (x === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSortDir = 'asc'
            }
            this.currentSort = x;
            this.getStockMovement()
        }
    },

    mounted() {
        let _ = this
        _.get()
        _.getStockMovement()
        _.$root.$on("paginate", (data) => {
            _.getStockMovement(data)
        })
    },
    beforeDestroy() {
        this.$root.$off("paginate");
    },
    watch: {
        search: function () {
            this.getStockMovement()
        },
    }
}
</script>

<style scoped>
/* custom radio input */
.custom-radio-group {
    display: flex;
    gap: 2rem;
    align-items: center;
}

.custom-radio {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    font-weight: 500;
}

.custom-radio input[type="radio"] {
    opacity: 0;
    position: absolute;
}

.radio-circle {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 2px solid #1592b4;
    border-radius: 50%;
    margin-right: 8px;
    position: relative;
    box-sizing: border-box;
}

.custom-radio input[type="radio"]:checked+.radio-circle::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    background-color: #1592b4;
    border-radius: 50%;
    transform: translate(-50%, -50%);
}

.img-carousel {
    width: 100%;
    height: 400px;
    object-fit: cover;
    object-position: center;
}
</style>